import _ from 'underscore';

export const generateTag = (type, tagTemplates, templateReplacements, uglify = false) => {
  const updatedTagTemplate = _.map(tagTemplates[type], (line) => {
    let ret = line;
    if (uglify) {
      ret = ret.trim();
    }
    Object.keys(templateReplacements).forEach((key) => {
      const templateKey = `{{${key}}}`;
      ret = ret.replace(new RegExp(templateKey, 'g'), templateReplacements[key]);
    });
    return ret;
  });
  return uglify ?
    updatedTagTemplate.join('') :
    updatedTagTemplate.join('\n');
};

export const getEventTagModel = (goalContext) => {
  const {
    Type, Action, Label, Value, Category, CurrencyCode, GoalValueType,
  } = goalContext;

  let tagProperties = {};
  let EventAction = '';
  if (Type === 'ProductConversionGoal') {
    EventAction = 'PRODUCT_PURCHASE';
    tagProperties = {
      ecomm_prodid: 'REPLACE_WITH_PRODUCT_ID', ecomm_pagetype: 'PURCHASE',
    };
  } else if (Type === 'EventGoal') {
    EventAction = Action;
    tagProperties = {
      event_label: Label, event_value: Value, event_category: Category,
    };
  }

  const isVariableRevenue = GoalValueType === 'VariantValue';
  const variableRevenuePlaceholder = '$Variable_revenue_placeholder$';
  if (isVariableRevenue) {
    tagProperties = { ...tagProperties, revenue_value: variableRevenuePlaceholder, currency: CurrencyCode };
  }
  let eventProperties = JSON.stringify(_.pick(tagProperties, value => !_.isEmpty(value) || _.isNumber(value)));
  eventProperties = eventProperties.replace(`"${variableRevenuePlaceholder}"`, 'Replace_with_Variable_Revenue_Function()');

  return {
    EventAction,
    EventProperties: eventProperties,
  };
};
